import { render } from "./Folder.vue?vue&type=template&id=3787843b"
import script from "./Folder.vue?vue&type=script&setup=true&lang=js"
export * from "./Folder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/exhishare/Folder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3787843b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3787843b', __exports__)) {
    api.reload('3787843b', __exports__)
  }
  
  module.hot.accept("./Folder.vue?vue&type=template&id=3787843b", () => {
    api.rerender('3787843b', render)
  })

}


export default __exports__